export const TEAM_NUMERABLE_TYPE = 'App\\Teams\\Team'
